import { Component, OnInit } from '@angular/core';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { FiltroRisco } from 'src/app/models/filtro-risco.model';
import { CriteriosAvaliacaoRiscoService } from 'src/app/services/criterios-avaliacao-risco.service';
import { RiscosChavesServices } from 'src/app/services/riscos-chaves.service';
import { RiscosService } from 'src/app/services/riscos.service';
import { BaseListComponent } from 'src/app/shared/components/base-list/base-list.component';
import { SharedService } from 'src/app/services/shared.service';
import { ModalSelecaoRiscoComponent } from '../modal-selecao-risco/modal-selecao-risco.component';
import { ActivatedRoute, Router } from "@angular/router";
import { IRiscosChavesProcessoItemModel } from 'src/app/models/riscos-chaves.model';
import { IMaginitudesEscalaRisco } from 'src/app/models/maginitudes-escala-risco.model';
import { ICriteriosAvaliacaoRiscos } from 'src/app/models/criterios-avaliacao-riscos.model';
import { MatTableDataSource } from '@angular/material/table';
import { EscalasService } from 'src/app/services/escalas.service';
import { NiveisRiscoInerenteService } from 'src/app/services/niveis-risco-inerente.service';
import { NiveisRiscoResidualService } from 'src/app/services/niveis-risco-residual.service';
import { ControleService } from 'src/app/services/controle.service';
import { event } from 'jquery';
import { INiveisRiscoInerente } from "../../../../models/niveis-risco-inerente.model";
import { INiveisRiscoResidual } from "../../../../models/niveis-risco-residual.model";
import {
  ModalAdicionarNaoCadastradoComponent
} from "../modal-adicionar-nao-cadastrado/modal-adicionar-nao-cadastrado.component";
import { UnidadeGestoraService } from "../../../../services/unidade-gestora.service";



@Component({
  selector: 'app-preenchimento-riscos-criterios',
  templateUrl: './preenchimento-riscos-criterios.component.html',
  styleUrls: ['./preenchimento-riscos-criterios.component.scss']
})
export class PreenchimentoRiscosCriteriosComponent extends BaseListComponent implements OnInit {

  public titulo: string;
  public filtro = {} as FiltroRisco;
  public modelRiscosChavesProcessoItem: IRiscosChavesProcessoItemModel = {} as IRiscosChavesProcessoItemModel;
  public modelCriterioAvaliacaoRisco: ICriteriosAvaliacaoRiscos = {} as ICriteriosAvaliacaoRiscos;
  public dataSource = new MatTableDataSource<IRiscosChavesProcessoItemModel>([]);
  public valorTotalRI: number = 0;
  public valorTotalRR: number = 0;
  public riscoControle: string;
  public nomeRisco: string;
  public nomeRiscoNaoCadastrado: string;
  public valor1: string;
  public valor2: string;
  public operador: string;
  public submit = false;
  id: number;
  processoId: number;
  unidadeGestoraId: number;
  displayedColumnDescricao: string[] = ['descricao'];
  displayedColumnEscalas: string[] = [];
  displayedColumns: string[] = ['ri', 'nivelRisco', 'situacao', 'riscoControle', 'rr', 'nivelRiscoResidual', 'acoes']
  valorRI: number;
  valorXpto: number;
  valorProbabilidade: number;
  subtipo: string;
  macroprocesso: string;
  processo: string;
  nomeUnidadeGestora: string;
  riscos: any[] = [
    { escalasCriterioAvaliacao: [], escala1: null, escala2: null, escala3: null, escala4: null }
  ];

  constructor(private riscosChavesService: RiscosChavesServices,
    private riscosService: RiscosService,
    private criteriosAvaliacaoService: CriteriosAvaliacaoRiscoService,
    private sharedService: SharedService,
    private unidadeGestoraService: UnidadeGestoraService,
    private matDialog: MatDialog,
    private route: ActivatedRoute,
    public router: Router,
    private nivelRiscoResidualService: NiveisRiscoResidualService,
    private nivelRiscoInerenteService: NiveisRiscoInerenteService,
    private controleService: ControleService
  ) {
    super();
  }

  async ngOnInit() {
    const modoVisualizar = localStorage.getItem('modoVisualizar');
    this.modoVisualizar = modoVisualizar  === 'true';

    this.titulo = this.modoVisualizar ? 'Visualizar' : 'Editar';

    const paramsRisco = this.sharedService.getParamsRiscos();

    this.subtipo = paramsRisco.subtipo;
    this.macroprocesso = paramsRisco.macroprocesso;
    this.processo = paramsRisco.processo;

    const unidadeGestorares =

    this.id = parseInt(this.route.snapshot.paramMap.get('id'));
    this.processoId = parseInt(this.route.snapshot.paramMap.get('processoId'));
    this.unidadeGestoraId = parseInt(this.route.snapshot.paramMap.get('unidadeGestoraId'));
    await this.riscosChavesService.obterPorId(this.id);
    await  this.unidadeGestoraService.obterPorId(this.unidadeGestoraId).then(res=>{
      if(res.sucesso){
        this.nomeUnidadeGestora = res.dados.sigla + ' ' + res.dados.nome;
      }
    });
    this.obterDescricaoRisco();

  }

  excluirRisco(index: number) {

    this.riscosChavesService
      .excluirProcesso(index)
      .then((res) => {
        if (res.sucesso) {
          this.exibirMensagemSucesso('Risco excluído com sucesso.');
        } else {
          this.exibirMensagemAlerta(res.mensagem.descricao);
        }
      })
      .catch((err) => {
        this.exibirMensagemErro(err.mensagem);
      })
      .finally(() => {
        this.obterDescricaoRisco();
      });
  }

  retornoAbaRisco() {
    this.router.navigateByUrl(`/unidades-gestoras/${this.unidadeGestoraId}?aba=4`);
  }

  public onBack() {
    this.submit = false;
    this.router.navigate([`/riscos-chaves-form/${this.id}`]);
    // this.router.navigateByUrl(`/unidades-gestoras/${this.unidadeGestoraId}?aba=4`);
  }
  public obterDescricaoRisco() {

    this.riscosChavesService
      .obterItensProcesso(this.id, this.processoId)
      .then((res) => {
        if (res.dados.length > 0) {
          if (res.dados[0].dadosFormulaRiscoInerente.length > 0) {
            this.verificaFormula(res.dados[0].dadosFormulaRiscoInerente);
          }

        }

        this.dataSource = new MatTableDataSource<IRiscosChavesProcessoItemModel>(res.dados);

        this.obterEscalas();
        this.inicializarValoresPadrao();

      })
      .catch((err) => {
        this.exibirMensagemErro(err.mensagem);
      })
  }


  public inicializarValoresPadrao() {

    this.displayedColumnEscalas.forEach((escala, indice) => {

      this.dataSource.data.forEach(risco => {
        const escalaEncontrada = risco.escalasCriterioAvaliacao.find(esc => esc.nome === escala);
        if (escalaEncontrada?.magnitudeEscala?.length) {
          const magnitudeKeys = ["magnitude_1Nome", "magnitude_2Nome", "magnitude_3Nome", "magnitude_4Nome", "magnitude_5Nome", "magnitude_6Nome"];

          if (indice < magnitudeKeys.length) {
            const magnitudeNome = risco[magnitudeKeys[indice]];
            const valorExistente = escalaEncontrada.magnitudeEscala.find(mag => mag.magnitude === magnitudeNome);
            risco[escala] = valorExistente ?? null;
          }
        }
      });
    });
    if (this.displayedColumns.includes('situacao')) {
      this.dataSource.data.forEach(risco => {

        if (risco.situacaoId) {
          const avaliacaoSelecionada = risco.situacaoSelecionada;
        }
      });

      this.dataSource._updateChangeSubscription(); // Atualiza a tabela
      this.calcularMagnitude();
    }




  }

  public buscarRisco() {

    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = 'modal-component';
    dialogConfig.width = '650px';
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;

    const modal = this.matDialog.open(ModalSelecaoRiscoComponent, dialogConfig);
    modal.afterClosed().subscribe((data) => {
      if (data) {
        this.filtro.pesquisa = data.id;
        this.adicionarRisco(data.id);
      }
    })
  }

  public async adicionarRisco(riscoId: number) {
    try {

      if (riscoId) {
        const result = await (await this.riscosService.obterPorId(riscoId)).dados;
        this.nomeRisco = result.nome;
      } else {
        this.nomeRisco = this.nomeRiscoNaoCadastrado;
        riscoId = 165;
      }
      if (this.id) {
        const res = await this.riscosChavesService.obterPorId(this.id).then((res) => {
          this.modelRiscosChavesProcessoItem.riscoChaveId = res.dados.id;
          this.modelRiscosChavesProcessoItem.criterioAvaliacaoId = res.dados.criterioAvaliacaoId;
          this.modelRiscosChavesProcessoItem.riscoId = riscoId;
          this.modelRiscosChavesProcessoItem.processoId = this.processoId;
          this.modelRiscosChavesProcessoItem.nomeRisco = this.nomeRisco;
        })

        const inserir = await this.riscosChavesService.inserirProcessoItem(this.modelRiscosChavesProcessoItem);
        if (inserir.sucesso)
          location.reload();
      }
    } catch (error) {
      console.error("Erro inesperado ao inserir o risco no processo!:", error);
    }

  }

  public obterEscalas() {

    if (this.dataSource.data.length > 0) {
      this.displayedColumnEscalas = this.dataSource.data[0].escalasCriterioAvaliacao.map(e => e.nome);
    }
  }
  public adicionarRiscoNaoCadastrado() {
    const dialogRef = this.matDialog.open(ModalAdicionarNaoCadastradoComponent, {
      width: '650px',
      hasBackdrop: true,
      disableClose: true,
      id: 'modal-risco-nao-cadastrado'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.nomeRiscoNaoCadastrado = result;
        this.adicionarRisco(null);
      }
    });

  }
  selecionarItem(risco: IRiscosChavesProcessoItemModel, escala: string, event: any) {


    if (!risco.magnitudeEscalaRisco) {
      risco.magnitudeEscalaRisco = [];
    }

    const magnitudeSelecionada = event.value;
    let existeMagnitude = false;

    for (var i = 0; i < risco.magnitudeEscalaRisco.length; i++) {
      if (risco.magnitudeEscalaRisco[i].escalasId == event.value.escalasId) {
        risco.magnitudeEscalaRisco[i] = magnitudeSelecionada;
        existeMagnitude = true;
        break;
      }
    }

    if (!existeMagnitude)
      risco.magnitudeEscalaRisco.push(event.value);

  }
  selecionarAvaliacao(risco: IRiscosChavesProcessoItemModel, event: any) {
    const avaliacaoSelecionada = risco.riscoControle.find(controle => controle.avaliacao === event);

    this.riscoControle = avaliacaoSelecionada.valorDoRisco;
    risco.situacaoId = avaliacaoSelecionada.id;
    risco.riscoControleRR = parseFloat(this.riscoControle.toString().replace(',', '.'));
    risco.situacaoSelecionada = avaliacaoSelecionada.avaliacao;

  }

  public verificaFormula(dadosFormula: any[]) {
    if (dadosFormula) {
      this.valor1 = dadosFormula[0].campo;
      this.valor2 = dadosFormula[1].campo;

      for (var i = 0; i < dadosFormula.length; i++) {
        if (dadosFormula[i].operador != "" && dadosFormula[i].operador != null) {
          this.operador = dadosFormula[i].operador
        }
      }
    }
  }


  public async salvarDados(salvarEFechar: boolean) {

    for (var i = 0; i < this.dataSource.data.length; i++) {
      await this.riscosChavesService.atualizarProcesso(this.dataSource.data[i]);
    }

    if (salvarEFechar) {
      this.exibirMensagemSucesso('Resposta Enviadas com Sucesso!');
      // this.router.navigateByUrl(`/unidades-gestoras/${this.unidadeGestoraId}?aba=4`);
      this.router.navigate([`/riscos-chaves-form/${this.id}`]);

    } else {
      this.exibirMensagemSucesso('Resposta Enviadas com Sucesso!');
    }

  }

  public calcularRI(risco: IRiscosChavesProcessoItemModel) {
    if (!risco.magnitudeEscalaRisco || risco.magnitudeEscalaRisco.length === 0) {
      console.warn("Lista magnitudeEscalaRisco vazia ou inexistente.");
      return;
    }

    const operador = this.operador; // Operação dinâmica
    const valores = risco.magnitudeEscalaRisco.map(item => Number(item.valor)).filter(v => !isNaN(v));

    if (valores.length === 0) {
      console.warn("Nenhum valor numérico válido encontrado em magnitudeEscalaRisco.");
      return;
    }

    let resultado = valores[0];

    for (let i = 1; i < valores.length; i++) {
      switch (operador) {
        case '+':
          resultado += valores[i];
          break;
        case '-':
          resultado -= valores[i];
          break;
        case '*':
          resultado *= valores[i];
          break;
        case '/':
          if (valores[i] !== 0) {
            resultado /= valores[i];
          } else {
            console.warn("Divisão por zero não permitida!");
          }
          break;
        default:
          console.warn(`Operador "${operador}" não reconhecido!`);
          return;
      }
    }

    // Se o valor do risco inerente não mudou, evitar recálculo
    if (risco.ri === resultado) {
      console.log("Nenhuma alteração no valor do risco inerente, cálculo ignorado.");
      return;
    }

    risco.ri = parseFloat(resultado.toFixed(2));

    this.nivelRiscoInerenteService
      .obter(String(risco.criterioAvaliacaoId), true)
      .then((res) => {
        const riscoInerenteVerificacao = this.determinarClassificacaoRI(Number(risco.ri), res.dados);

        if (riscoInerenteVerificacao) {
          risco.nivelRiscoRINome = riscoInerenteVerificacao.nome;
          risco.idNomeNivelRisco = riscoInerenteVerificacao.id;
        }
      })
      .catch((err) => {
        this.exibirMensagemErro(err.mensagem);
      });

    this.calcularMagnitude();
  }


  public determinarClassificacaoRI(valorEntrada: number, criterios: INiveisRiscoInerente[]): { nome: string; id: number } | undefined {
    for (const criterio of criterios) {
      const valor = parseFloat(criterio.valor);
      const valor1 = criterio.valor_1 ? parseFloat(criterio.valor_1) : undefined;

      let condicao1 = false;
      let condicao2 = criterio.operador_1 && valor1 !== undefined ? false : true;

      switch (criterio.operador) {
        case "=":
          condicao1 = valorEntrada === valor;
          break;
        case "!=":
          condicao1 = valorEntrada !== valor;
          break;
        case ">":
          condicao1 = valorEntrada > valor;
          break;
        case "<":
          condicao1 = valorEntrada < valor;
          break;
        case ">=":
          condicao1 = valorEntrada >= valor;
          break;
        case "<=":
          condicao1 = valorEntrada <= valor;
          break;
      }

      if (criterio.operador_1 && valor1 !== undefined) {
        switch (criterio.operador_1) {
          case "=":
            condicao2 = valorEntrada === valor1;
            break;
          case "!=":
            condicao2 = valorEntrada !== valor1;
            break;
          case ">":
            condicao2 = valorEntrada > valor1;
            break;
          case "<":
            condicao2 = valorEntrada < valor1;
            break;
          case ">=":
            condicao2 = valorEntrada >= valor1;
            break;
          case "<=":
            condicao2 = valorEntrada <= valor1;
            break;
        }
      }

      if (condicao1 && condicao2) {
        return { nome: criterio.nome, id: criterio.id };
      }
    }
    return undefined;
  }

  public calcularRR(risco: IRiscosChavesProcessoItemModel) {
    const formula = risco.dadosFormulaRiscoResidual;

    let operador = formula.operador;
    let campo1: any = formula.campo_1;
    let campo2: any = formula.campo_2;

    // Substituindo os campos pelo valor correto
    switch (campo1) {
      case 'Valor do Risco Inerente':
        campo1 = risco.ri;
        break;
      case 'Risco do Controle':
        campo1 = this.riscoControle;
        break;
    }

    switch (campo2) {
      case 'Valor do Risco Inerente':
        campo2 = risco.ri;
        break;
      case 'Risco do Controle':
        campo2 = this.riscoControle;
        break;
    }

    // Garantindo que os valores são números e não concatenam strings
    let valor1 = Number(campo1);
    let valor2 = Number(campo2.toString().replace(',', '.'));

    if (isNaN(valor1) || isNaN(valor2)) {
      console.error("Erro: Um dos valores não é um número válido!", { valor1, valor2 });
      return;
    }

    let resultado = 0;

    switch (operador) {
      case '+':
        resultado = valor1 + valor2;
        break;
      case '-':
        resultado = valor1 - valor2;
        break;
      case '*':
        resultado = valor1 * valor2;
        break;
      case '/':
        if (valor2 !== 0) {
          resultado = valor1 / valor2;
          break;
        } else {
          console.warn("Divisão por zero não permitida!");
          return;
        }
      default:
        console.error(`Erro: Operador "${operador}" não reconhecido!`);
        return;
    }

    // Se o valor do risco residual não mudou, não recalcula magnitude
    if (risco.rr === resultado) {
      console.log("Nenhuma alteração no valor do risco residual, cálculo ignorado.");
      return;
    }

    this.nivelRiscoResidualService
      .obter(String(risco.criterioAvaliacaoId), true)
      .then((res) => {
        const riscoResidualVerificacao = this.determinarClassificacaoRR(Number(risco.ri), res.dados);
        risco.nivelRiscoRRNome = riscoResidualVerificacao.nome;
        risco.idNomeNivelRiscoRR = riscoResidualVerificacao.id;
      })
      .catch((err) => {
        this.exibirMensagemErro(err.mensagem);
      });

    // Atualiza o valor do risco residual
    risco.rr = parseFloat(resultado.toFixed(2));

    // Chama calcularMagnitude() apenas se houve mudança nos valores
    this.calcularMagnitude();
  }




  public determinarClassificacaoRR(valorEntrada: number, criterios: INiveisRiscoResidual[]): { nome: string; id: number } | undefined {
    for (const criterio of criterios) {
      const valor = parseFloat(criterio.valor);
      const valor1 = criterio.valor_1 ? parseFloat(criterio.valor_1) : undefined;

      let condicao1 = false;
      let condicao2 = criterio.operador_1 && valor1 !== undefined ? false : true;

      switch (criterio.operador) {
        case "=":
          condicao1 = valorEntrada === valor;
          break;
        case "!=":
          condicao1 = valorEntrada !== valor;
          break;
        case ">":
          condicao1 = valorEntrada > valor;
          break;
        case "<":
          condicao1 = valorEntrada < valor;
          break;
        case ">=":
          condicao1 = valorEntrada >= valor;
          break;
        case "<=":
          condicao1 = valorEntrada <= valor;
          break;
      }

      if (criterio.operador_1 && valor1 !== undefined) {
        switch (criterio.operador_1) {
          case "=":
            condicao2 = valorEntrada === valor1;
            break;
          case "!=":
            condicao2 = valorEntrada !== valor1;
            break;
          case ">":
            condicao2 = valorEntrada > valor1;
            break;
          case "<":
            condicao2 = valorEntrada < valor1;
            break;
          case ">=":
            condicao2 = valorEntrada >= valor1;
            break;
          case "<=":
            condicao2 = valorEntrada <= valor1;
            break;
        }
      }

      if (condicao1 && condicao2) {
        return { nome: criterio.nome, id: criterio.id };
      }
    }
    return undefined;
  }


  public calcularMagnitude() {
    // Resetando os valores totais antes de calcular
    this.valorTotalRI = 0;
    this.valorTotalRR = 0;

    for (let i = 0; i < this.dataSource.data.length; i++) {
      let item = this.dataSource.data[i];

      // Somando apenas valores numéricos válidos
      if (!isNaN(Number(item.ri))) {
        this.valorTotalRI += Number(item.ri);
      }

      if (!isNaN(Number(item.rr))) {
        this.valorTotalRR += Number(item.rr);
      }
    }

    this.valorTotalRI = parseFloat(this.valorTotalRI.toFixed(2));
    this.valorTotalRR = parseFloat(this.valorTotalRR.toFixed(2));
  }

}

